export default __webpack_public_path__ + "static/yellow-09939c7e3751449d2067e01aa956cdd8.svg";